export default __webpack_public_path__ + "static/media/back_rand5.9d66728f.jpg";